import PropTypes from "prop-types";
import { Box, Typography } from "@mui/material";
import { ArrowLeft, Lock } from "lucide-react";

import { Button } from "../../components/Button";
import { readOnlyClientMessage } from "../../utils/clientAccess";
import { panelSx } from "./campaign/campaignUi";

/** Replaces the content creation pages when the client is read-only on the Free plan. */
export function ReadOnlyClientNotice({ clientName, onBack }) {
  return (
    <Box sx={{ p: { xs: 2, md: 3 } }}>
      <Box sx={{ ...panelSx, p: 4, maxWidth: 520, mx: "auto", display: "flex", flexDirection: "column", alignItems: "center", textAlign: "center", gap: 1.5 }}>
        <Lock size={32} color="#9CA3AF" />
        <Typography sx={{ fontWeight: 800, fontSize: "1.0625rem", color: "#0F172A" }}>
          {clientName ? `${clientName} está en solo lectura` : "Cliente en solo lectura"}
        </Typography>
        <Typography sx={{ fontSize: "0.875rem", color: "#6B7280" }}>
          {readOnlyClientMessage} No se puede crear contenido nuevo para este cliente.
        </Typography>
        <Button variant="outline" onClick={onBack}>
          <ArrowLeft size={15} /> Volver a contenidos
        </Button>
      </Box>
    </Box>
  );
}

ReadOnlyClientNotice.propTypes = {
  clientName: PropTypes.string,
  onBack: PropTypes.func.isRequired,
};
